import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FinanceiroService from 'services/FinanceiroService';

export const initialState = {
	loading: false,
	loadingExtrato: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	categorias: [],
	extratoPaginado: {
		content: [],
		totalElements: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 10,
	},
}

export const saldo = createAsyncThunk('financeiro/saldo',async () => {
    const response = await FinanceiroService.saldo()
    return response;
})

export const baixar = createAsyncThunk('financeiro/baixar',async (data, { rejectWithValue }) => {
	try {
		const response = await FinanceiroService.baixar(data);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao baixar saldo empresa')
	}
})

export const getExtratoPaginado = createAsyncThunk('financeiro/extratoPaginado', async (params, { rejectWithValue }) => {
	try {
		const response = await FinanceiroService.extratoPaginado(params);
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar extrato')
	}
})

export const getCategorias = createAsyncThunk('financeiro/categorias', async (_, { rejectWithValue }) => {
	try {
		const response = await FinanceiroService.categorias();
		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro ao buscar categorias')
	}
})

export const financeiroService = createSlice({
	name: 'financeiro',
	initialState,
	reducers: {

	},
    extraReducers: (builder) => {
		builder
			.addCase(saldo.pending, (state) => {
				state.loading = true
			})
			.addCase(saldo.fulfilled, (state, action) => {
				state.loading = false
				state.saldo = action.payload
			})
			.addCase(saldo.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(getExtratoPaginado.pending, (state) => {
				state.loadingExtrato = true
			})
			.addCase(getExtratoPaginado.fulfilled, (state, action) => {
				state.loadingExtrato = false
				const payload = action.payload || {}
				state.extratoPaginado = {
					content: payload.content || [],
					totalElements: payload.totalElements || 0,
					totalPages: payload.totalPages || 0,
					currentPage: payload.number || 0,
					pageSize: payload.size || 10,
				}
			})
			.addCase(getExtratoPaginado.rejected, (state, action) => {
				state.loadingExtrato = false
				state.message = action.payload
				state.showMessage = true
			})
			.addCase(getCategorias.fulfilled, (state, action) => {
				state.categorias = action.payload || []
			})
	},
})

export const {
	showLoading,
} = financeiroService.actions

export default financeiroService.reducer
